<script setup>
import { onMounted, ref } from 'vue'
import {Icon, Input, ProfilePicture, Textarea} from '@components'
import { getPrice, showDurationUnit } from '@utils'

import CenterLayout from './CenterLayout.vue'

import { useStaff } from '@store/staff.js'
const $staff = useStaff()

onMounted(() => {
    $staff.fetchData()
})


// const questions = ref('Awesome! Do you have a favourite hair expert?')

const selectedStaff = ref(null)

import { useChatCustomizer } from '@store/chatCustomizer';
const $chatCustomizer = useChatCustomizer();

import {useSettings} from '@store/settings';
const $settings = useSettings();

</script>

<template>
  <CenterLayout>
    <div class="h-[66px] w-[297px] rounded-md overflow-hidden m-auto mb-10">
      <img @click="$chatCustomizer.changeSecondaryMenu('service')" :src="Image('chat-customizer-top-banner.png')" class="opacity-30 cursor-pointer" alt="">
    </div>

    <div class="mb-10 text-center font-semibold text-lg">...</div>
    <div class="rounded-[14px] p-5 flex flex-col gap-5 bg-white w-[381px] m-auto">
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Questions</div>
        <Textarea v-model="$settings.settings.chat_widget.staff.question"></Textarea>
      </div>
     
      <div class="flex flex-col gap-2">
        <div v-for="staff in $staff.getStaffs" :key="staff.staff_id" @click="selectedStaff = staff.staff_id" class="flex items-center gap-3 rounded-xl p-[12px_16px_12px_16px] cursor-pointer border-[1.5px]" :class="[selectedStaff == staff.staff_id ? 'border-transparent bg-[#F2F4F7]' : 'border-[#D0D5DD]']">
            <ProfilePicture :name="staff.display_name" :img="staff.meta?.profile_image_url" :bgColor="staff.meta?.color" :textClass="`!w-[64px] !h-[64px]`" :imgClass="`!w-[64px] !h-[64px]`" />
            <div class="flex flex-col gap-2 w-full">
              <div class="text-base font-semibold text-[#101828]">{{ staff.display_name }}</div>
              <div v-if="staff.meta?.title" class="text-[#475467] text-base">{{ staff.meta?.title }}</div>
            </div>
        </div>
      </div>
    </div>

    <template #sidebar>
      <div class="mt-[44px]">
        <div class="text-[#101828] text-xs font-semibold">Pro Tips</div>
        <div class="text-[#101828] text-lg font-semibold mt-1">Staff</div>
        <ul class="pl-5 mt-1 text-sm text-[#475467] list-disc">
          <li>Your staff list will be updated from your system automatically.</li>
          <li>You can change staff items from dashboard.</li>
        </ul>
      </div>
    </template>
  </CenterLayout>
</template>


<style>

</style>